import * as React from 'react';

export default function ConfirmDeclarationIcon({
  color = 'primary',
}: {
  color: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 120 120"
    >
      <defs>
        <clipPath id="a">
          <path
            d="M0 0h64.786v101.344H0z"
            data-name="Rectangle 1557"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
      </defs>
      <g data-name="Groupe 8358">
        <g
          data-name="Groupe 8356"
          style={{
            clipPath: 'url(#a)',
          }}
          transform="rotate(-32 59.853 17.165)"
        >
          <path
            d="M57.1 48.961a6.872 6.872 0 0 0-3.314.748 7.9 7.9 0 0 0-6.415-3.209 7.11 7.11 0 0 0-3.635.962 7.921 7.921 0 0 0-6.093-2.886 10.533 10.533 0 0 0-1.817.214V26.618a8.018 8.018 0 0 0-16.036 0v33.674l-3.849-5.88a6.986 6.986 0 0 0-5.024-3.1A8.441 8.441 0 0 0 5.144 52.6a8.789 8.789 0 0 0-3.528 4.811 7.256 7.256 0 0 0 .855 5.773c.107.214 16.036 24.267 18.815 28.329 3.421 5.024 10.263 8.552 16.677 8.552h6.2a20.465 20.465 0 0 0 20.525-20.2V56.978a7.591 7.591 0 0 0-7.59-8.018m3.1 30.574v.428a16.018 16.018 0 0 1-16.034 15.715h-6.2a16.863 16.863 0 0 1-12.935-6.628C22.249 84.987 6.427 60.934 6.32 60.72A2.518 2.518 0 0 1 6 58.582a3.5 3.5 0 0 1 1.6-2.138 3.855 3.855 0 0 1 2.141-.644h.535a2.634 2.634 0 0 1 1.817 1.069l8.125 12.294a2.39 2.39 0 0 0 2.566.962 2.311 2.311 0 0 0 1.6-2.245V26.618a3.421 3.421 0 0 1 6.842 0V59.33a2.258 2.258 0 0 0 2.245 2.245 2.332 2.332 0 0 0 2.245-2.245V49.6a3.6 3.6 0 0 1 1.817-.535 3.356 3.356 0 0 1 3.1 2.138v8.659a2.258 2.258 0 0 0 2.245 2.245 2.332 2.332 0 0 0 2.245-2.245V51.74a3.645 3.645 0 0 1 2.031-.748 3.336 3.336 0 0 1 3.207 2.352v7.59a2.245 2.245 0 1 0 4.49 0v-6.842a3.137 3.137 0 0 1 5.024 2.779v22.664z"
            data-name="Trac\xE9 4419"
            style={{
              fill: color,
            }}
            transform="translate(.094 1.284)"
          />
          <path
            d="M25.945 14a2.258 2.258 0 0 0 2.245-2.245v-9.51A2.258 2.258 0 0 0 25.945 0 2.332 2.332 0 0 0 23.7 2.245v9.514A2.191 2.191 0 0 0 25.945 14"
            data-name="Trac\xE9 4420"
            style={{
              fill: color,
            }}
            transform="translate(1.636)"
          />
          <path
            d="M14.276 17.483a2.325 2.325 0 0 0 3.207 0 2.325 2.325 0 0 0 0-3.207l-6.734-6.735a2.268 2.268 0 0 0-3.207 3.207z"
            data-name="Trac\xE9 4421"
            style={{
              fill: color,
            }}
            transform="translate(.476 .476)"
          />
          <path
            d="M11.759 28.19A2.258 2.258 0 0 0 14 25.945a2.332 2.332 0 0 0-2.241-2.245H2.245A2.258 2.258 0 0 0 0 25.945a2.332 2.332 0 0 0 2.245 2.245z"
            data-name="Trac\xE9 4422"
            style={{
              fill: color,
            }}
            transform="translate(0 1.636)"
          />
          <path
            d="M38.4 25.845a2.258 2.258 0 0 0 2.245 2.245h9.514a2.258 2.258 0 0 0 2.241-2.245 2.332 2.332 0 0 0-2.241-2.245h-9.514a2.258 2.258 0 0 0-2.245 2.245"
            data-name="Trac\xE9 4423"
            style={{
              fill: color,
            }}
            transform="translate(2.651 1.629)"
          />
          <path
            d="M36.345 18.125a2.357 2.357 0 0 0 1.6-.641l6.735-6.735a2.268 2.268 0 0 0-3.207-3.207l-6.735 6.735a2.325 2.325 0 0 0 0 3.207 2.357 2.357 0 0 0 1.6.641"
            data-name="Trac\xE9 4424"
            style={{
              fill: color,
            }}
            transform="translate(2.354 .476)"
          />
        </g>
      </g>
    </svg>
  );
}
